export class Society {
  id!: number;
  name!: string;
  created_at:  Date = new Date();
  updated_at:  Date = new Date();
}
